var _path, _path2, _g, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 72,
    viewBox: "0 0 70 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 54.4727L45.3651 50.0007L51.0766 67.0706L42.8075 64.5649L37.7115 71.5425L32 54.4727Z",
    fill: "#123766"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7109 50L30.0761 54.4719L24.3646 71.5417L19.2685 64.5642L10.9995 67.0698L16.7109 50Z",
    fill: "#123766"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4766_6535)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 33,
    r: 25,
    fill: "#123766"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 33,
    r: 24,
    stroke: "url(#paint0_linear_4766_6535)",
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3423 24.7774V22.8801C24.3423 22.1815 24.8253 21.6152 25.4211 21.6152H35.7473C36.3432 21.6152 36.8262 22.1815 36.8262 22.8801V24.7774M24.3423 24.7774H21.7072C21.1113 24.7774 20.6283 25.3437 20.6283 26.0423V27.3072C20.6449 29.7398 21.6138 30.9092 24.6201 32.7341M24.3423 24.7774L24.3423 30.9717C24.3423 31.5695 24.4403 32.163 24.6201 32.7341M36.8262 24.7774H39.4006C39.9964 24.7774 40.4794 25.3437 40.4794 26.0423V27.3072C40.4337 29.8748 39.4267 31.0541 36.4578 32.7341M36.8262 24.7774V30.9717C36.8262 31.5249 36.6949 32.1271 36.4578 32.7341M30.5526 37.4262V40.5884M30.5526 37.4262C27.9026 37.4262 25.4304 35.3081 24.6201 32.7341M30.5526 37.4262C33.1171 37.4262 35.5548 35.0458 36.4578 32.7341M30.5526 40.5884C33.1761 41.7151 34.8625 42.4793 35.5692 43.3298C35.9646 43.8057 35.5075 44.3831 34.9408 44.3831H26.1102C25.5663 44.3831 25.134 43.8435 25.5234 43.3983C26.2909 42.5208 28.1798 41.7316 30.5526 40.5884Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3168 24.7773V30.4693C27.4275 31.9734 27.9604 32.6546 28.9351 32.9991",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4766_6535",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4766_6535"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4766_6535",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4766_6535",
    x1: 3.5,
    y1: 11,
    x2: 101,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D7E0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerBadge);
export default __webpack_public_path__ + "static/media/winnerBadge.6abd5e23c127ac9bbf8a0f96893c33df.svg";
export { ForwardRef as ReactComponent };